export default __webpack_public_path__ + "static/media/survey-thumbs-up.1d714050.svg";